// TagSelector.js
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Tag = styled.div`
  display: flex;
  align-items: center;
  background-color: #f1f1f1;
  border-radius: 5px;
  padding: 8px 12px;
  font-size: 14px;
`;

const TagSelector = ({ tags, populateField, fieldName1, fieldName2 }: any) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    setData(tags);
  }, [tags]);
  return (
    <TagContainer>
      {data?.map((item: any) => (
        <Tag key={item?._id || item?._tempId}>
          {item?.[populateField]?.[fieldName1]} - {item?.[fieldName2]}
        </Tag>
      ))}
    </TagContainer>
  );
};

export default TagSelector;
